export default __webpack_public_path__ + "static/media/lock-red.509a5031.svg";